import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byFullName',
  pure: false,
  standalone: false
})
export class ByFullNamePipe implements PipeTransform {
  public transform(items: any[], name: string): any[] {
    return name && name.trim()
      ? items.filter((item) => {
          const search = name.toLowerCase();
          return item.FullName?.toLowerCase().includes(search) || item.PersonnelId?.toLowerCase().includes(search);
        })
      : items;
  }
}
